import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Stack } from '@optimus-web/core';
import { ApplicationState } from '@mews-commander/types';
import { withScopeContext } from '@mews/framework';
import { SummaryRowBody } from '../../SummaryRow';
import ProductName from '../../../../../../../components/commander-ui/ProductName';
import { getProductCount } from '../../../../../selectors';

interface ProductListProps {
    productIds: string[];
}

const ProductRow = ({ productIds }: ProductListProps) => (
    <Stack spacing="100" vertical>
        {productIds.map((productId) => (
            <ProductItem
                key={productId}
                text={<ProductName productId={productId} />}
                productId={productId}
                data-test-product-id={productId}
            />
        ))}
    </Stack>
);

export default ProductRow;

interface StateProps {
    count: number;
}

interface OwnProps {
    productId: string;
    scope: string;
}

const ProductItem = withScopeContext(
    connect<StateProps, null, OwnProps, ApplicationState>(
        createStructuredSelector({
            count: getProductCount,
        })
    )(SummaryRowBody)
);
